import { Injectable, inject } from '@angular/core';
import { SiaSelectBoxDataApi } from '../apis/sia-select-box-data-api';
import { SiaSessionService } from './session.service';

@Injectable({
  providedIn: 'root',
})
export class SiaSelectBoxDataService {
  private api = inject(SiaSelectBoxDataApi);
  private siaSessionService = inject(SiaSessionService);

  async loadFullData(
    key: any,
    foreignKey: string,
    order: boolean,
    selectable: boolean = false,
    useCache = true,
    force: boolean = false,
    orderByKey?: string,
    orderByAsc?: boolean,
    connectionStringName?: string,
  ): Promise<any> {
    var datasource: any[] = [];
    var k = 'selectbox' + key + foreignKey + order;
    k = k.replace('-', '');
    if (!useCache || (foreignKey != undefined && foreignKey != null)) {
      datasource = await this.loadData(key, foreignKey, order, selectable, k, connectionStringName);
    } else {
      let itemsJson = this.siaSessionService.weakMemoryGet(k);
      if (itemsJson && !force) {
        datasource = JSON.parse(itemsJson);
      } else {
        datasource = await this.loadData(key, foreignKey, order, selectable, k, connectionStringName);
      }
    }
    let sortKey = Object.keys(datasource[0] ?? {}).find(
      (x) => x.toLowerCase() === orderByKey?.toLowerCase(),
    );
    sortKey = sortKey ?? 'description';
    datasource.sort((a, b) => {
      if (sortKey) {
        if (typeof a[sortKey] === 'number' && typeof b[sortKey] === 'number') {
          if (orderByAsc) {
            return b[sortKey] - a[sortKey];
          } else {
            return a[sortKey] - b[sortKey];
          }
        } else {
          if (orderByAsc) {
            return String(b[sortKey]).localeCompare(String(a[sortKey]));
          } else {
            return String(a[sortKey]).localeCompare(String(b[sortKey]));
          }
        }
      } else {
        return 0;
      }
    });
    return datasource;
  }

  loadFullRadarData(
    key: any,
    value: any,
    foreignKey: string,
    order: boolean,
    selectable: boolean = false,
    useCache = false,
  ): Promise<any> {
    var k = '' + key + foreignKey + order + 'radar';
    k = k.replace('-', '');
    if (!useCache) {
      var res = this.loadRadarData(
        key,
        value,
        foreignKey,
        order,
        selectable,
        k,
      );
      return Promise.resolve(res);
    }
    let item = this.siaSessionService.weakMemoryGet(k);
    let items: any;
    if (item) {
      items = JSON.parse(item);
      return Promise.resolve(items);
    }

    var res = this.loadRadarData(key, value, foreignKey, order, selectable, k);
    return Promise.resolve(res);
  }

  private loadData(
    key: any,
    foreignKey: any,
    order: boolean,
    selectable: boolean,
    k: string,
    connectionStringName?: string,
  ): Promise<any> {
    return this.api
      .loadFullData(key, foreignKey, order, selectable, connectionStringName)
      .then((items: any[]) => {
        if (items && items.length < 200) {
          this.siaSessionService.weakMemorySet(k, JSON.stringify(items));
          return items;
        } else {
          return items;
        }
      });
  }

  private loadRadarData(
    key: any,
    value: any,
    foreignKey: string,
    order: boolean,
    selectable: boolean,
    k: string,
  ): any {
    return this.api
      .loadRadarData(key, value, foreignKey, order, selectable)
      .then((items: any) => {
        if (items && !items.disabled) {
          this.siaSessionService.weakMemorySet(k, JSON.stringify(items));
          return items;
        } else {
          return items;
        }
      });
  }
}
